import * as React from "react";

import { makeStyles, Typography } from "@material-ui/core";

import { AccordionHeader, AccordionHeaderIcon } from "client/components";

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: theme.typography.fontWeightBold,
    marginRight: theme.spacing(1),
  },
}));

export const BankInfoAccordionHeader: React.FC<{
  stepInfo: {
    "aria-controls": string;
    "data-testid": string;
    id: string;
    labelkey: string;
  };
  isExpanded: boolean;
  isExpandable: boolean;
  shouldShowCheckmark: boolean;
  headerLabel: string;
}> = ({
  isExpanded,
  isExpandable,
  stepInfo,
  shouldShowCheckmark,
  headerLabel,
}) => {
  const classes = useStyles();
  return (
    <AccordionHeader
      {...stepInfo}
      expanded={isExpanded}
      isExpandable={isExpandable}
    >
      <Typography className={classes.label} variant="body2">
        {headerLabel}
      </Typography>
      <AccordionHeaderIcon show={shouldShowCheckmark} />
    </AccordionHeader>
  );
};
